import { FC } from "react";
import { useTranslation } from "react-i18next";
import config from "src/config";
import { useClientHeight } from "@/hooks/useClientHeight";
import { Result } from "@/ui";
import { StyledWelcome } from "./styled";

const Welcome: FC = () => {
  const height = useClientHeight();

  const { t } = useTranslation();

  return (
    <StyledWelcome $height={height}>
      <Result
        title={t('welcome')}
        message={t('app_description')}
        image="error.svg"
      >
        <p>
          {t('did_not_receive_link')}
          {' '}
          <a href={`${config.patient_url}/contact-us`} target="_blank" rel="noreferrer">
            {t('contact_support')}
          </a>
        </p>
      </Result>
    </StyledWelcome>
  );
};

export default Welcome;